Vue.component('make-model-search', {
    props: [
        'searchJson',
        'currentFranchise',
        'dealershipId'
    ],
    data: function () {
        return {
            loaded: false,
            json: [],
            makes: [],
            models: [],
            url: '/search',
            postcode: '',
            selected: {
                car_type: 0,
                make: 0,
                model: '',
                type: 'cash',
                min_cash: 0,
                max_cash: 0,
                min_monthly: 0,
                max_monthly: 0,
                postcode: '',
                url: '',
            },
            franchise: ''
        };
    },
    created: function () {
        var vm = this;

        vm.loaded = true;

        if (isJson(vm.searchJson)) {
            vm.json = JSON.parse(vm.searchJson);
        } else {
            vm.json = vm.searchJson;
        }

        vm.franchise = vm.currentFranchise;

        // T118559 - do not set vauxhall as default make for vauxhall franchise
        if (vm.franchise != '' && vm.franchise != 'vauxhall') {

            for (var i = 0; i < vm.json.standardMake.length; i++) {
                if (i != 0 && vm.franchise == vm.json.standardMake[i].display_name.toLowerCase().replace(/\s+/g, '-')) {
                    vm.selected.make = i;
                    console.log(i);
                }
            }

            vm.change_make();
        }

        vm.makes = vm.json.standardMake;

        vm.check_url();
    },
    methods: {
        clear_car_type: function () {
            var vm = this;
            vm.selected.car_type = 0;
        },

        change_make: function () {
            var vm = this;
            vm.models = [];
            vm.models = vm.json.make_model_list[vm.json['standardMake'][vm.selected.make].display_name];

            // clear model as we need to reset models dropdown to nothing selected
            vm.clear_model();
        },

        clear_make: function () {
            var vm = this;
            vm.selected.make = 0;
            vm.models = [];
            vm.selected.model = '';
        },

        clear_model: function () {
            var vm = this;
            vm.selected.model = '';
        },
        check_url: function () {
            var vm = this,
                extra = '',
                url = '';

            vm.url = '/search';

            if (vm.franchise != '') {
                vm.url = '/' + vm.franchise + vm.url
            }

            if (vm.dealershipId != '') {
                vm.url += '/dealership/' + vm.dealershipId;
            }

            if (vm.selected.make != 0) {
                url = vm.json['standardMake'][vm.selected.make]['url'];
                extra = vm.strip_url(url).replace(/\/$/, "");
                vm.url += extra;
            }

            if (vm.selected.model || vm.selected.model === 0) {

                // T111271 - change the character that replaces spaces
                extra = '/model/' + vm.models[vm.selected.model].replace(/\s+/g, '-');
                vm.url += extra.toLowerCase();
            }

            if (vm.selected.car_type != 0) {
                url = vm.json['One_Search_Ads'][vm.selected.car_type]['url'];
                extra = vm.strip_url(url);
                vm.url += extra;
            }

            if (vm.url == '/search') {
                vm.url = '/search/';
            } else {
                vm.url += '/sort/price_asc/';
            }

        },
        strip_url: function (url) {

            url = url.replace('/search', '').replace('/sort/price_asc', '');

            // T111271 - change the character that replaces spaces
            url = url.split(' ').join('-');
            return url;
        }
    }
});

var search = new Vue({
    delimiters: ['[%', '%]'],
    el: "#makeModelSearchEl"
});

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

$(document).ready(function () {
    "use strict";

    //we don't want the form to submit as GET because it adds the input names to the query string and ruins our lovely
// URL but we also don't want to POST it because it the "breaks" the back button so we turn it into a link

    $(document).on('submit', '#makeModelSearchForm', function (e) {
        e.preventDefault();
        window.location.href = $('#makeModelSearchForm').attr('action');
    });
});